import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Outlet, Route, Routes } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Wrapper from 'common/navigation/wrapper';
import SearchOverviewContainer from './overview/search-results-overview-container';
import SearchTypeContainer from './type/search-results-type-container';
import { search } from './search-actions';
import SearchRelationsContainer from './relations/search-relations-container';

const SearchContainer = ({ intl }) =>
  <Wrapper title={intl.formatMessage({ id: 'common.titles.SEARCH' })}>
    <Routes>
      <Route
        path=':searchValue/type/:type/page/:page/relations/:relationId'
        element={<SearchRelationsContainer />}
      />
      <Route path=':searchValue/type/:type/page/:page' element={<SearchTypeContainer />} />
      <Route
        path=':searchValue/type/:type/relations/:relationId'
        element={<SearchRelationsContainer />}
      />
      <Route path=':searchValue/type/:type' element={<SearchTypeContainer />} />
      <Route
        path=':searchValue/relations/:relationId'
        element={<SearchRelationsContainer />}
      />
      <Route path=':searchValue' element={<SearchOverviewContainer />} />
    </Routes>
    <Outlet />
  </Wrapper>;
const mapDispatchToProps = { search };

SearchContainer.propTypes = {
  intl: PropTypes.object,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(SearchContainer));
